var _defs, _rect, _path, _polyline, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 127.82 114.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient);}.cls-2,.cls-3{fill:#63ffe5;}.cls-3{stroke:#5fffc8;stroke-linecap:round;stroke-miterlimit:10;stroke-width:8px;}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 576.95,
    cy: 57.41,
    r: 132.46,
    gradientTransform: "translate(-224.57 2.74) scale(0.5 0.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#38758b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#307889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#198183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08877f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.5,
    y: 3.5,
    width: 120.82,
    height: 107.82,
    rx: 30.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M94.21,7a26.64,26.64,0,0,1,26.61,26.6V81.22a26.64,26.64,0,0,1-26.61,26.6H33.6A26.63,26.63,0,0,1,7,81.22V33.6A26.63,26.63,0,0,1,33.6,7H94.21m0-7H33.6A33.6,33.6,0,0,0,0,33.6V81.22a33.6,33.6,0,0,0,33.6,33.6H94.21a33.6,33.6,0,0,0,33.61-33.6V33.6A33.6,33.6,0,0,0,94.21,0Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "65.94 30.9 65.94 57.41 65.94 83.92"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.14,
    y1: 57.41,
    x2: 89.73,
    y2: 57.41
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusoff);
export default __webpack_public_path__ + "static/media/Plus off.ef9b62a7431d1e72b02059a07a96ad10.svg";
export { ForwardRef as ReactComponent };